import { useDispatch, useSelect } from '@wordpress/data';
import { createContext, useContext, useEffect } from 'react';
import MODAL_STORE from './store';
export var ModalContext = /*#__PURE__*/createContext({
  dialog: {}
});
export var useModalContext = function () {
  return useContext(ModalContext);
};
/**
 * @param {{ baseId: string, visible: boolean }} dialog
 * @return {{ isUnderLayer: boolean }}
 */

export var useModalState = function (dialog) {
  var _useDispatch = useDispatch(MODAL_STORE),
      mount = _useDispatch.mount,
      unmount = _useDispatch.unmount;

  var baseId = dialog.baseId,
      visible = dialog.visible;
  useEffect(function () {
    if (visible) {
      mount(baseId);
    } else {
      unmount(baseId);
    }

    return function () {
      unmount(baseId);
    };
  }, [baseId, visible, mount, unmount]);
  var isUnderLayer = useSelect(function (select) {
    return select(MODAL_STORE).getIsUnderLayer(baseId);
  });
  return {
    isUnderLayer: isUnderLayer
  };
};